import React from 'react';
import T from 'prop-types';

const VerticalBar = ({ value, base, maxHeight, color, width }) => {
  const safeBase = base === 0 ? 1 : base;
  const height = Math.max((maxHeight * value) / safeBase, 1);
  const style = { height: `${height}px` };

  if (width != null) style.width = typeof width === 'number' ? `${width}px` : width;

  return <div className={`vertical-bar-chart flex-grow b-rds bg-${color}`} style={style} />;
};

VerticalBar.propTypes = {
  value: T.number.isRequired,
  base: T.number.isRequired,
  maxHeight: T.number.isRequired,
  color: T.string.isRequired,
  width: T.oneOfType([T.string, T.number]),
};

export default VerticalBar;
